import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {TaskGeneral} from './TaskGeneral';
import TaskVisit from './TaskVisit';
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import {taskTypeIDs} from '../../../../constants/taskTypes';
import ButtonAction from '../../../ButtonAction';
import ModalContainer from '../../../ModalContainer';
import ModalButtonsContainer from '../../../ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../styles/styles';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';

const PopupContent = ({taskID, taskType, onClose, onSubmit}) => {
  const intl = useIntl();
  const prefix = 'tab-order-inspections-tasks-button';
  const isNewTask = taskID === -1;
  const getHeader = () => {
    if (isNewTask) {
      return taskType === taskTypeIDs.general
        ? intl.formatMessage({id: `${prefix}-label-general`, defaultMessage: 'Create mission general'})
        : intl.formatMessage({id: `${prefix}-label-visit`, defaultMessage: 'Create mission visit'});
    } else return intl.formatMessage({
      id: `${prefix}-label-editTask`,
      defaultMessage: `Edit task ${taskID}`
    }, {id: taskID});
  };

  const {formik} = useTaskAndNotesGridContext();
  const {isValid, dirty, setFieldValue} = formik;
  useEffect(() => {
    setFieldValue('taskTypeID', taskType);
  }, []);

  return (
    <>
      {(taskType === taskTypeIDs.general)
        ? <TaskGeneral header={getHeader()}/>
        : <TaskVisit header={getHeader()}/>
      }
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          label={intl.formatMessage({id: `${prefix}-close`, defaultMessage: 'Close'})}
          onClick={onClose}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={intl.formatMessage({id: `${prefix}-submit`, defaultMessage: 'Submit'})}
          onClick={onSubmit}
          disabled={!(isValid && dirty)}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

const PopupCreateEditTask = ({
                               taskType,
                               taskID = -1,
                               onOpen,
                               onEdit,
                               disabled
                             }) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = async () => {
    setShow(true);
    if (onOpen) {
      await onOpen(taskID);
    }
  };

  const intl = useIntl();
  const prefix = 'tab-order-inspections-tasks-button-label';
  const isNewTask = taskID === -1;

  const handleEdit = async () => {
    if (onEdit) {
      await onEdit();
    }
    handleCloseModal();
  };

  const getLabel = () => {
    if (isNewTask) {
      return (
        <>
          <img
            src={toAbsoluteUrl(`/media/common/Plus_white.svg`)}
            alt="create" className={'mr-2'}
          />
          {taskType === taskTypeIDs.general
            ? intl.formatMessage({id: `${prefix}-general`, defaultMessage: 'Create mission general'})
            : intl.formatMessage({id: `${prefix}-visit`, defaultMessage: 'Create mission visit'})
          }
        </>
        );
    } else {
      return <img src={'../../../media/common/Edit_primary.svg'} alt="edit" className="w-20px h-20px"/>;
    }
  };

  return (
    <>
      {isNewTask
        ? (
          <ButtonAction
            variant={taskType === taskTypeIDs.general ? 'warning' : 'primary'}
            label={getLabel()}
            onClick={handleShowModal}
            disabled={disabled}
            customClassnames={'w-225px mx-2'}
          />
        )
        : (
          <ButtonAction
            variant={'icon'}
            iconButtonType={'primary'}
            label={getLabel()}
            onClick={handleShowModal}
            disabled={disabled}
          />
        )
      }
      <ModalContainer show={show} onClose={handleCloseModal} size={'md'}>
        <PopupContent
          taskID={taskID}
          taskType={taskType}
          onClose={handleCloseModal}
          onSubmit={handleEdit}
        />
      </ModalContainer>
    </>
  );
};

export default PopupCreateEditTask;
